import React from "react";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import { ImgBackCardOne } from "../../../assets/logos/icons";
import "./card-template.css";

const CardTemplatePure = (props) => {
  const {
    url,
    toggleDialog,
    altImg,
    imgBackCard,
    img,
    title,
    text,
    text2,
    text3,
  } = props;

  return (
    <Link to={url} onClick={toggleDialog}>
      <Grid item xs={12} lg={12} md={12} sm={12}>
        <Grid className="card-button-container">
          <div className="img-card-template">
            {imgBackCard ? (
              <img src={imgBackCard} className="img-background-card" />
            ) : (
              <img src={ImgBackCardOne} className="img-background-card" />
            )}
            <img className="img-icon-card" alt={altImg} src={img} />
          </div>
          <div className="text-card-container">
            <span className="title-card">{title}</span>
            <p
              className={
                text2 || text3
                  ? "description-texts-first"
                  : "description-text-card"
              }
            >
              {text}
            </p>
            {text2 ? <p className="description-texts-others">{text2}</p> : ""}
            {text3 ? <p className="description-texts-others">{text3}</p> : ""}
          </div>
        </Grid>
      </Grid>
    </Link>
  );
};

export { CardTemplatePure as default };
